import $ from 'jquery';
import 'slick-carousel';
import animateDivs from './so-animate';
import addClickEventToMembers from './so-post-feed-scripts';
import './so-post-feed-scripts';
import './so-video-scripts';

$('.toggle-menu').on('click', function () {
  $('#site-navigation').toggleClass('active')
  $('.toggle-menu').toggleClass('active')
})

$('.menu-item-has-children > a').on('click', function(e) {
  const $link = $(this)
  const $submenu = $link.parent().find('.sub-menu')
  if ( $(window).width() < 768 && !$submenu.is(':visible') ) {
    e.preventDefault()
    $('.sub-menu').slideUp()
    $submenu.slideDown()
  }
})

if ( $('.video-slideshow-block').length ) {
  $('.video-slideshow-block').each( function () {
    const $container = $(this)
    const $slideshow = $('.slideshow-images', this)
    const $slideshowNav = $('.slideshow-nav', this)
    $slideshowNav.slick({
      slidesToShow: 5,
      slidesToScroll: 5,
      prevArrow: $('.arrow-prev', $container),
      nextArrow: $('.arrow-next', $container),
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            dots: true
          }
        }
      ]
    })

    $('.slideshow-image-wrapper', $slideshowNav).on('click', function () {
      const videoId = $(this).data('video-id')
      const $slide = $(this)
      const ifrm = document.createElement('iframe');
          ifrm.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&enablejsapi=1`);
          ifrm.setAttribute('frameborder', '0')
          ifrm.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture')
          ifrm.setAttribute('allowfullscreen', true)

      $('.slideshow-image', $slideshow).html(ifrm)
      $('.slideshow-image-container', $slideshowNav).removeClass('active')
      $('.slideshow-image-container', $slide).addClass('active');
    })

  })
}

setTimeout( function () {
  if ( $('.testimonials-block').length ) {
    $('.testimonials-block').each( function () {
      const $container = $(this)
      const $slideshow = $('.testimonials', this)
      $slideshow.slick({
        slidesToShow : 3,
        slidesToScroll : 3,
        prevArrow: $('.arrow-prev', $container),
        nextArrow: $('.arrow-next', $container),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            }
          }
        ]
      })
    })
  }
}, 500)

// if ( $('.video-slideshow-block').length ) {
//   $('.video-slideshow-block .slideshow-nav .slideshow-image-wrapper').on('click', function () {
//     const videoId = $(this).data('video-id')
//     const slide = $(this)
//     const ifrm = document.createElement('iframe');
//         ifrm.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1`);
//         ifrm.setAttribute('frameborder', '0')
//         ifrm.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture')
//         ifrm.setAttribute('allowfullscreen', true)
//     const slideParent = slide.closest('.video-slideshow-block')
//
//     console.log(slideParent)
//     $('.slideshow-images .slideshow-image', slideParent).html(ifrm)
//   })
// }

if ( $('.newsletter-signup').length ) {
  $('.newsletter-signup form').on('submit', function(e) {
    e.preventDefault()
    $('.so-email').removeClass('error');
    $('.newsletter-alert').html('')
    var name = $('.so-name').val()
    var email = $('.so-email').val()
    if( email.length ){
      $('.newsletter-signup').addClass('loading');
      signup_user(email, name);
    } else {
      $('.so-email').addClass('error');
    }
  });
}

function signup_user(email, name) {
  console.log(email, name)
  $.ajax({
    url: ajaxurl,
    method: 'post',
    type: 'json',
    data: {
      'action': 'do_ajax',
      'fn' : 'sign_up_user',
      'email' : email,
      'name' : name
    }
  }).done( function (response) {
    console.log(response)
    $('.newsletter-signup').removeClass('loading');
    response = $.parseJSON(response);
    if ( response.status === 'successful signup') {
      $('.newsletter-signup form').hide()
    }
    $('.newsletter-alert').html('<div class="response-text">'+response.response+'</div>');
  });
}

if ( $('.post-slider-block').length ) {
  $('.post-slider-block').each( function () {
    const $slideshow = $('.post-previews', this)
    const $container = $(this)
    $slideshow.slick({
      slidesToShow : 3,
      slidesToScroll : 3,
      arrows: true,
      prevArrow: $('.arrow-prev', $container),
      nextArrow: $('.arrow-next', $container),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    })
  })
}

if ( $('.slideshow-block').length ) {
  $('.slideshow-block').each( function () {
    const $container = $(this)
    const $slideshowNav = $('.slideshow-nav', $container)
    const $slideshowNavWrapper = $('.slideshow-nav-wrapper', $container)
    const $slideshow = $('.slideshow-images', $container)
    const $slideshowWrapper = $('.slideshow-wrapper', $container)
    $slideshow.slick({
      slidesToShow : 1,
      slidesToScroll : 1,
      useNavFor: $slideshowNav,
      dots: false,
      arrows: true,
      prevArrow: $('.arrow-prev', $slideshowWrapper),
      nextArrow: $('.arrow-next', $slideshowWrapper)
    })
    $slideshowNav.slick({
      slidesToShow: 5,
      slidesToScroll: 5,
      useNavFor: $slideshow,
      prevArrow: $('.arrow-prev', $slideshowNavWrapper),
      nextArrow: $('.arrow-next', $slideshowNavWrapper),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            dots: true
          }
        }
      ]
    })

  })
}

if ( $('.instructor-slides').length ) {
  $('.instructor-slides-wrapper').each( function () {
    const $container = $('.instructor-slides', this)
    const $slideshow = this
    // If need to reinit click after resize use this:
    // .on('setPosition', function() {
    //   addClickEventToMembers()
    // })
    $container.slick({
      slidesToShow : 3,
      slidesToScroll : 3,
      dots: false,
      arrows: true,
      prevArrow: $('.arrow-prev', $slideshow),
      nextArrow: $('.arrow-next', $slideshow),
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    })
  })
}

addClickEventToMembers();


if ( $('.animate').length ) {
  $(document).ready(function () {
    setTimeout( function() {
      animateDivs()
    }, 1000)
    $(window).on('scroll', function() {
      if ( $('.animate:not(.animated)').length ) {
        console.log('scrolling')
        animateDivs()
      }
    })
  })
}

$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top + ($(window).height() / 2);
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};



// WEBPACK FOOTER //
// ./js/scripts.js